'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _transformers = require('../../utils/transformers');

var allPartsTransformer = function allPartsTransformer(transformers) {
  return function (value, data, breakpointName) {
    var preparedValue = (0, _transformers.prepareForTransform)(value);
    return (0, _transformers.transformValues)(transformers, preparedValue, data, breakpointName);
  };
};

exports.default = allPartsTransformer;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/transformers/composite/allPartsTransformer.js
// module id = 343
// module chunks = 168707334958949